import Config from '@config';
import { createApi } from '@reduxjs/toolkit/query/react';

import { ReferenceBook } from '@/features/referenceBooks/types';
import axiosBaseQuery from '@/utils/axiosBaseQuery';

/** Industry classification picker for the connection-application form — see
 * ConnectionApplicationEntity.IndustryId. Read-only proxy onto the platform-wide reference book. */
export const industriesApi = createApi({
  reducerPath: 'industriesApi',
  baseQuery: axiosBaseQuery({
    baseUrl: Config.VITE_API_URL + '/industries',
  }),
  endpoints: builder => ({
    getIndustries: builder.query<ReferenceBook[], void>({
      query: () => ({ url: '' }),
    }),
  }),
});

export const { useGetIndustriesQuery } = industriesApi;
